import Emitter from "../Emitter";

/**
 * Creates an events api
 *
 * @type {(
 * 	successEmitter: import("../Emitter/types").IEmitter,
 * 	errorEmitter: import("../Emitter/types").IEmitter,
 * ) => import("./types").IGqlEventsApi}
 */
const eventsApi = (successEmitter, errorEmitter) => ({
	on: successEmitter.on,
	onError: errorEmitter.on,
	listener: {
		onSuccess: (operation, result, context) =>
			successEmitter.notify(operation.operationName, operation.variables, result, context),
		onError: (operation, error, context) =>
			errorEmitter.notify(operation.operationName, operation.variables, error, context),
	},
});

/**
 * Creantes GqlEvents PubSub
 * @type {() => import("./types").IGqlEventsApi}
 */
const GqlEvents = () => eventsApi(Emitter(), Emitter());

export default GqlEvents;
